import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { hotjar } from "../utils/hotjar";

export const HotjarRouteInterceptor: FC = () => {
  const location = useLocation();

  useEffect(() => {
    hotjar.stateChange(location.pathname);
  }, [location]);

  return <></>;
};
